import { Adapter as r, getAdapter as o } from "../../../adapter.js";
import { CheckoutDesignModel as t } from "./design.model.js";
import { CheckoutDesignImagesAdapter as i } from "./images/images.adapter.js";
import { CheckoutDesignColorsAdapter as m } from "./colors/colors.adapter.js";
class c extends r {
  adapt(e) {
    return new t({
      images: o(i).adapt(e == null ? void 0 : e.images),
      colors: o(m).adapt(e.colors),
      fontFamily: e.font_family
    });
  }
  serialize(e) {
  }
}
export {
  c as CheckoutDesignAdapter
};
//# sourceMappingURL=design.adapter.js.map
